import {
    PublicCourse,
    PublicEducator,
    PublicOccurrence,
} from '@cademy-package/sdk-component-types';
import { FunctionComponent } from 'react';
import { InPersonBookButton } from './components/InPersonBookButton';
import { OnDemandBookButton } from './components/OnDemandBookButton';
import { OnRequestBookButton } from './components/OnRequestBookButton';

type PrimaryBookButtonProps = {
    bookableOccurrences: Array<PublicOccurrence>;
    course: PublicCourse;
    educator: PublicEducator;
    membershipRequired: boolean;
};

export const PrimaryBookButton: FunctionComponent<PrimaryBookButtonProps> = ({
    bookableOccurrences,
    course,
    educator,
    membershipRequired,
}) => {
    switch (course.type) {
        case 'class':
            return (
                <InPersonBookButton
                    bookableOccurrences={bookableOccurrences}
                    course={course}
                    educator={educator}
                />
            );
        case 'blended':
            return (
                <InPersonBookButton
                    bookableOccurrences={bookableOccurrences}
                    course={course}
                    educator={educator}
                />
            );
        case 'on-demand':
            return (
                <OnDemandBookButton
                    course={course}
                    educator={educator}
                    membershipRequired={membershipRequired}
                />
            );
        case 'on-request':
            return <OnRequestBookButton course={course} educator={educator} />;
    }
};
